import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {
  ETIQUETA_VERSION,
  VERSION_FISCAL,
  VERSION_NO_FISCAL,
  useVersionContable,
} from './versionContable';

const TEXTO_MUTED = '#9AA8C2';

/** Selector fiscal / no fiscal del sidebar de Contabilidad. No se muestra si
 *  el negocio no usa las dos versiones. */
export default function SelectorVersionContable() {
  const { cargado, activa, version, soloFiscal, pendientes, cambiarVersion, refrescar } =
    useVersionContable();

  // Al entrar al módulo se vuelve a preguntar: el negocio pudo activar la
  // función (Parámetros) después de la primera carga de la sesión.
  useEffect(() => {
    refrescar();
  }, []);

  if (!cargado || !activa) return null;

  return (
    <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
      <Typography
        sx={{ color: TEXTO_MUTED, fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.06em', mb: 0.6 }}
      >
        VERSIÓN
      </Typography>
      <ToggleButtonGroup
        exclusive
        fullWidth
        size="small"
        value={version}
        disabled={soloFiscal}
        onChange={(_e, valor) => valor && cambiarVersion(valor)}
        aria-label="Versión contable"
        sx={{
          bgcolor: 'rgba(255,255,255,0.06)',
          borderRadius: 1.4,
          '& .MuiToggleButton-root': {
            color: '#D2DBEB',
            border: 0,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.8rem',
            py: 0.55,
            borderRadius: '10px !important',
            '&.Mui-selected, &.Mui-selected:hover': { bgcolor: '#FFFFFF', color: '#1A2B4C' },
            '&.Mui-disabled': { color: 'rgba(210,219,235,0.45)' },
            '&.Mui-selected.Mui-disabled': { color: '#1A2B4C' },
          },
        }}
      >
        <ToggleButton value={VERSION_NO_FISCAL}>{ETIQUETA_VERSION[VERSION_NO_FISCAL]}</ToggleButton>
        <ToggleButton value={VERSION_FISCAL}>{ETIQUETA_VERSION[VERSION_FISCAL]}</ToggleButton>
      </ToggleButtonGroup>
      <Typography sx={{ color: TEXTO_MUTED, fontSize: '0.7rem', mt: 0.7, lineHeight: 1.3 }}>
        {version === VERSION_FISCAL
          ? 'Solo consulta: asientos ya pasados a fiscal.'
          : `${pendientes} ${pendientes === 1 ? 'asiento pendiente' : 'asientos pendientes'} de pasar a fiscal.`}
      </Typography>
    </Box>
  );
}
